import { type SegmentData } from './use-pie-chart-data'

interface CreateChartOptionsProps {
  segmentOne: number
  segmentTwo: number
  segmentThree: number
  segmentFour?: number
  highlightedSegment: number
  showPercentage?: boolean
  createSegment: (segment: number, isInner: boolean) => SegmentData
  fontSize: number
}

export const createChartOptions = ({
  segmentOne,
  segmentTwo,
  segmentThree,
  segmentFour,
  highlightedSegment,
  showPercentage = true,
  createSegment,
  fontSize,
}: CreateChartOptionsProps): unknown => {
  const filledPartMap: Record<number, number> = {
    1: segmentOne,
    2: segmentTwo,
    3: segmentThree,
    4: segmentFour ?? 0,
  }

  const percentage = filledPartMap[highlightedSegment]

  const extraProgressOuterData = segmentFour ? [createSegment(3, false)] : []

  const extraProgressInnerData = segmentFour ? [createSegment(3, true)] : []

  return {
    series: [
      {
        name: 'Progress Outer',
        type: 'pie',
        startAngle: 90,
        radius: ['75%', '90%'],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        silent: true,
        label: {
          show: Boolean(showPercentage),
          position: 'center',
          formatter: `${percentage.toString()}%`,
          fontSize,
          fontWeight: '600',
          color: '#000',
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          disabled: true,
        },
        data: [createSegment(0, false), createSegment(1, false), createSegment(2, false), ...extraProgressOuterData],
      },
      {
        name: 'Progress Inner',
        type: 'pie',
        startAngle: 90,
        radius: ['0%', '75%'],
        silent: true,
        labelLine: {
          show: false,
        },
        emphasis: {
          disabled: true,
        },
        data: [createSegment(0, true), createSegment(1, true), createSegment(2, true), ...extraProgressInnerData],
      },
    ],
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  }
}
